(function () {
  'use strict';

  var PROPERTY_NAME = 'Subscription savings';
  var PROPERTY_SELECTOR = '[data-kccs-subscription-savings]';

  function selectedValue(form, name) {
    var fields = form.querySelectorAll('[name="' + name + '"]');
    var fallback = '';

    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if (field.disabled) continue;
      if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) continue;
      if (field.value) return String(field.value);
      fallback = String(field.value || fallback);
    }

    return fallback;
  }

  function parseCents(value) {
    if (value === null || value === undefined || value === '') return null;
    var normalized = String(value).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    var amount = Number(normalized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';
    var locale = document.documentElement.lang || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function productJson(form) {
    var sectionInput = form.querySelector('[name="section-id"]');
    var script = null;

    if (sectionInput && sectionInput.value) {
      script = document.getElementById('ProductJson-' + sectionInput.value);
    }
    if (!script) script = document.querySelector('script[id^="ProductJson-"]');
    if (!script) return null;
    if (script.kccsProductData) return script.kccsProductData;

    try {
      script.kccsProductData = JSON.parse(script.textContent);
      return script.kccsProductData;
    } catch (error) {
      return null;
    }
  }

  function savingsFromProductJson(form, planId) {
    var product = productJson(form);
    var variantId = selectedValue(form, 'id');
    if (!product || !variantId || !Array.isArray(product.variants)) return null;

    var variant = product.variants.find(function (candidate) {
      return String(candidate.id) === String(variantId);
    });
    if (!variant || !Array.isArray(variant.selling_plan_allocations)) return null;

    var allocation = variant.selling_plan_allocations.find(function (candidate) {
      return String(candidate.selling_plan_id) === String(planId);
    });
    if (!allocation) return null;

    return {
      regular: Number(variant.price),
      subscription: Number(allocation.price)
    };
  }

  function savingsFromSubscriptionCard(form) {
    var card = form.closest('[data-product-card]');
    if (!card) return null;

    var variantSelect = form.querySelector('[data-variant-select]');
    var selectedOption = variantSelect && variantSelect.options
      ? variantSelect.options[variantSelect.selectedIndex]
      : null;
    var regularText = selectedOption
      ? selectedOption.getAttribute('data-one-time')
      : (card.querySelector('[data-one-time-price]') || {}).textContent;
    var subscriptionText = selectedOption
      ? selectedOption.getAttribute('data-subscription')
      : (card.querySelector('[data-subscription-price]') || {}).textContent;
    var regular = parseCents(regularText);
    var subscription = parseCents(subscriptionText);

    return regular !== null && subscription !== null
      ? { regular: regular, subscription: subscription }
      : null;
  }

  function selectedPlanText(form) {
    var select = form.querySelector('select[name="selling_plan"]');
    if (select && select.options && select.selectedIndex >= 0) {
      return select.options[select.selectedIndex].textContent || '';
    }

    var checked = form.querySelector('input[name="selling_plan"]:checked');
    var label = checked && checked.id
      ? form.querySelector('label[for="' + checked.id.replace(/"/g, '\\"') + '"]')
      : null;
    return (label && label.textContent) || form.textContent || '';
  }

  function savingsLabel(form, planId) {
    var prices = savingsFromProductJson(form, planId) || savingsFromSubscriptionCard(form);

    if (prices && prices.regular > prices.subscription && prices.subscription >= 0) {
      var saved = prices.regular - prices.subscription;
      var percent = Math.round((saved / prices.regular) * 100);
      return percent + '% — ' + formatMoney(saved) + ' saved this delivery (' +
        formatMoney(prices.regular) + ' → ' + formatMoney(prices.subscription) + ')';
    }

    var match = selectedPlanText(form).match(/([0-9]+(?:\.[0-9]+)?)\s*%\s*off/i);
    return match ? match[1] + '% off applied to this delivery' : 'Subscription price applied';
  }

  function syncSavingsProperty(form) {
    if (!form || !form.matches('form')) return;

    var planId = selectedValue(form, 'selling_plan');
    var property = form.querySelector(PROPERTY_SELECTOR);

    if (!planId) {
      if (property) property.remove();
      return;
    }

    if (!property) {
      property = document.createElement('input');
      property.type = 'hidden';
      property.name = 'properties[' + PROPERTY_NAME + ']';
      property.setAttribute('data-kccs-subscription-savings', '');
      form.appendChild(property);
    }

    property.value = savingsLabel(form, planId);
  }

  document.addEventListener('change', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form') : null;
    if (form && (event.target.name === 'selling_plan' || event.target.name === 'id' || event.target.hasAttribute('data-variant-select'))) {
      syncSavingsProperty(form);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var submit = event.target && event.target.closest
      ? event.target.closest('button[type="submit"], input[type="submit"]')
      : null;
    if (submit) syncSavingsProperty(submit.form || submit.closest('form'));
  }, true);

  document.addEventListener('submit', function (event) {
    syncSavingsProperty(event.target);
  }, true);
}());
